import * as React from 'react';
import { Row, Col, Button, Card, Tag } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const styles = {

  detailWrapper: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 14,
    color: '#444',
    paddingBottom: 10,
    paddingTop: 10,
  },

  detailLabel: {
    width: 180,
    fontWeight: '500',
    textAlign: 'right',
    paddingRight: 5,
    whiteSpace: 'nowrap'
  },

  detailData: {
    fontWeight: '400',
    color: 'rgba(0, 0, 0, 0.65)'
  }

}

type Props = {
  supplier: Object,
  onClickEditSupplier: Function,
}

export default class extends React.PureComponent<Props> {

  render () {
    const { supplier, onClickEditSupplier } = this.props;

    return (
      <Row style={{ marginBottom: 20 }}>

        <Col span={12}>

          <h1>
            {supplier.company_name}
          </h1>

        </Col>

        <Col span={12} className="text-right">

          <Button type="default" onClick={onClickEditSupplier}>
            Edit Supplier
          </Button>

        </Col>

        <Col span={24}>

          <Card>

            <Row>

              <Col span={12}>

                <div style={styles.detailWrapper}>
                  <div style={styles.detailLabel}>
                    Company Name :
                  </div>
                  <div style={styles.detailData}>
                    { supplier.company_name }
                  </div>
                </div>

                <div style={styles.detailWrapper}>
                  <div style={styles.detailLabel}>
                    Trading Name :
                  </div>
                  <div style={styles.detailData}>
                    { supplier.trading_name || '-' }
                  </div>
                </div>

                <div style={styles.detailWrapper}>
                  <div style={styles.detailLabel}>
                    Email :
                  </div>
                  <div style={styles.detailData}>
                    { supplier.email || '-' }
                  </div>
                </div>

                <div style={styles.detailWrapper}>
                  <div style={styles.detailLabel}>
                    Phone :
                  </div>
                  <div style={styles.detailData}>
                    { supplier.phone || '-' }
                  </div>
                </div>

                <div style={styles.detailWrapper}>
                  <div style={styles.detailLabel}>
                    Website :
                  </div>
                  <div style={styles.detailData}>
                    { supplier.website || '-' }
                  </div>
                </div>

              </Col>

              <Col span={12}>

                <div style={styles.detailWrapper}>
                  <div style={styles.detailLabel}>
                    Payment Terms :
                  </div>
                  <div style={styles.detailData}>
                    { supplier.payment_terms || '-' }
                  </div>
                </div>

                <div style={styles.detailWrapper}>
                  <div style={styles.detailLabel}>
                    Default Currency :
                  </div>
                  <div style={styles.detailData}>
                    { supplier.default_currency }
                  </div>
                </div>

                <div style={styles.detailWrapper}>
                  <div style={styles.detailLabel}>
                    Account Number :
                  </div>
                  <div style={styles.detailData}>
                    { supplier.account_number || '-' }
                  </div>
                </div>

                <div style={styles.detailWrapper}>
                  <div style={styles.detailLabel}>
                    Active :
                  </div>
                  <div style={styles.detailData}>
                    {supplier.active ? (
                      <Tag icon={<CheckOutlined />} color="success">Active</Tag>
                    ) : (
                      <Tag icon={<CloseOutlined />} color="default">Inactive</Tag>
                    )}
                  </div>
                </div>

              </Col>

            </Row>

          </Card>

        </Col>

      </Row>
    );
  }
}
